import React from "react";
import { FooterSlot, Root, ScrollRegion } from "./ScrollableTableViewport.styles";
import type { ScrollableTableViewportProps } from "./ScrollableTableViewport.types";

/**
 * Flex-friendly wrapper: scrollable table body with optional pinned footer
 * (pagination). Matches add-instance preview — sticky `DataTable` headers
 * work when this region scrolls and the footer stays put.
 */
export const ScrollableTableViewport: React.FC<ScrollableTableViewportProps> = ({
  children,
  footer,
  minHeight,
  maxScrollHeight,
  variant = "card",
  hideScrollbar = false,
  insetTableChrome = false,
  shrinkToContent = false,
  horizontalOverflow = "auto",
  onScroll,
  scrollRegionTestId,
  className,
}) => (
  <Root
    className={className}
    $variant={variant}
    $minHeight={minHeight}
    $shrinkToContent={shrinkToContent}
  >
    <ScrollRegion
      $hideScrollbar={hideScrollbar}
      $maxScrollHeight={maxScrollHeight}
      $insetTableChrome={insetTableChrome}
      $shrinkToContent={shrinkToContent}
      $horizontalOverflow={horizontalOverflow}
      data-horizontal-overflow={horizontalOverflow}
      onScroll={onScroll}
      data-testid={scrollRegionTestId}
    >
      {children}
    </ScrollRegion>
    {footer ? <FooterSlot>{footer}</FooterSlot> : null}
  </Root>
);

export default ScrollableTableViewport;
